<template>
  <div class="member-wrapper common-bottom-space">
    <div class='content'>
      <div class="header-wrap">
        <div class="head-icon-box">
          <common-upload-file :fileType='1' method="UpdateUserHeadPath" @fileUpload="uploadFile($event)" :picUrl="params.UserHeadPath">
          </common-upload-file>
        </div>
      </div>
      <van-cell-group>
        <van-field v-model.trim="params.Name" required clearable label="姓名" name="fullName" maxlength=10 v-validate="rules.fullName" :error-message="errors.first('fullName')" placeholder="请输入姓名" />
        <van-field v-model="genderText" readonly label="性别" name="genderText" placeholder="请选择" @click="modalShow.gender=true" is-link />
        <van-field readonly clickable name="calendar" :value="params.Birthday" label="生日信息" placeholder="点击选择生日信息" @click="showCalendar = true" />
        <van-field v-model.trim="params.Mobile" :readonly='isMobileReadOnly' clearable name="mobile" v-validate="rules.mobile" :error-message="errors.first('mobile')" label="联系电话" />
        <van-field v-model.trim="params.Email" :readonly='isEmailReadOnly' required clearable label="邮箱" name="email" v-validate="rules.email" :error-message="errors.first('email')" placeholder="请输入邮箱" />
        <van-field v-model.trim="params.HospitalTextName" required clearable maxlength=25 label="医院名称" name="hospitalName" v-validate="rules.hospitalName" :error-message="errors.first('hospitalName')" placeholder="请输入医院名称" />
        <van-field v-model.trim="params.ZipCode" clearable label="邮编" name="zipCode" v-validate="rules.zipCode" :error-message="errors.first('zipCode')" placeholder="请输入邮编" />
        <van-field v-model="addressText" required label="省市区" name="provinceArea" v-validate="rules.provinceArea" :error-message="errors.first('provinceArea')" placeholder="请选择" @click="modalShow.area = true" is-link />
        <van-field v-model.trim="params.Address" required clearable maxlength=500 name="hospitalAddress" v-validate="rules.hospitalAddress" :error-message="errors.first('hospitalAddress')" label="医院地址" placeholder="请输入医院地址" />
        <van-field v-model="certificateText" readonly label="资格证书" @click="handleToCertificate" is-link />
        <van-field v-model.trim="params.Introduction" type='textarea' clearable label="简介" maxlength=500 placeholder="描述不超过500字" :show-word-limit="true" />
      </van-cell-group>
      <div class='common-btn-wrap'>
        <van-button type="info" round size="large" :disabled="saveDisabled" @click='handleSave'>保存</van-button>
      </div>
    </div>
    <!--性别-->
    <van-popup v-model="modalShow.gender" position="bottom">
      <van-picker show-toolbar :columns="optData.gender" @confirm="changeGenderOptData" @cancel="closeModal('gender')" value-key="text" />
    </van-popup>

    <!--省市区-->
    <van-popup v-model="modalShow.area" position="bottom">
      <div class="select-area-wrap">
        <div class="btn">
          <a class="cancel" @click="closeModal('area')">取消</a>
          <a class="confirm" @click="confirmChoseAreaData">确定</a>
        </div>
        <div class="list-box">
          <van-picker class="area-list" :columns="optData.areaOpt.country" @change="getSubArea" :default-index="choseAreaKey.countryIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.province" @change="getSubArea" :default-index="choseAreaKey.provinceIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.city" @change="getSubArea" :default-index="choseAreaKey.cityIndex" value-key="Name" />
          <van-picker class="area-list" :columns="optData.areaOpt.area" @change="getSubArea" :default-index="choseAreaKey.areaIndex" value-key="Name" />
        </div>
      </div>
    </van-popup>
    <van-calendar :default-date="defaultBirthDate" v-model="showCalendar" @confirm="birthConfirm"  />
  </div>
</template>
<script>
import CommonUploadFile from '@/components/common/upload';
import { Toast, Area } from "vant";
import store from "@/store";
export default {
  data () {
    return {
      params: {
        AppID: this.GLOBAL.AppID,
        // Method: 'UpdateUserRegister',
        Method: 'UpdateUserRegisterV1',
        RegionID: '',//地区编号
        Address: '',//详细地址:maxlength:500
        SurName: '',//姓:maxlength:50
        GivenName: '',//名:maxlength:50
        Name: '',//姓名
        Sex: 1,//性别:1:男,2:女
        Mobile: '',//手机:maxlength:11,第一次填写开通手机帐号,后续可以不填写,但是禁止和第一次填写不同
        Email: '',//邮箱:maxlength:100,第一次填写开通邮箱帐号,后续可以不填写,但是禁止和第一次填写不同
        HospitalTextName: '',//医院名称:认证前不能为空,认证后填写无效,maxlength:200
        ZipCode: '',//邮编:maxlength:50
        TelePhone: '',//固定电话:maxlength:200
        Introduction: '',//简介:maxlength:500
        UserHeadPath: '',//用户头像:maxlength:500 
        Birthday: '' // guandong_20220706
      },
      RegisterParams: {
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserRegister',
      },
      certificateText: '',
      genderText: '',
      addressText: '',
      isMobileReadOnly: false,
      isEmailReadOnly: false,
      saveDisabled: false,
      count: 0,
      rules: {
        fullName: { required: true },
        mobile: { formatMobile: true },
        email: { required: true, formatEmail: true },
        hospitalName: { required: true },
        zipCode: { formatZipCode: true },
        provinceArea: { required: true },
        hospitalAddress: { required: true },
      },
      optData: {//选项数据
        gender: [{ text: '男', value: '1' }, { text: '女', value: '2' }],
        product: [],
        areaOpt: {
          country: [],
          province: [],
          city: [],
          area: []
        }
      },
      areaName: {
        1: 'country',
        2: 'province',
        3: 'city',
        4: 'area'
      },
      choseAreaKey: {
        countryIndex: 0,
        provinceIndex: 0,
        cityIndex: 0,
        areaIndex: 0
      },
      modalShow: {
        gender: false,
        area: false
      },
      areaTemp: true,
      showCalendar: false, // guandong_20220706
      defaultBirthDate: new Date()
    }
  },
  methods: {
    init () {
      this.$Request(this.RegisterParams).then(res => {
        if (res) {
          var UserObj = res;
          this.params.RegionID = UserObj.AreaItem.RegionID;
          this.params.Address = UserObj.AreaItem.Address;
          this.params.Name = UserObj.SurName + UserObj.GivenName;
          if (UserObj.Account.indexOf('@') > -1) {
            this.isEmailReadOnly = true
          } else {
            this.isMobileReadOnly = true
          }
          this.params.Sex = UserObj.Sex;
          this.genderText = UserObj.Sex === 1 ? '男' : '女'
          this.params.Mobile = UserObj.Mobile;
          this.params.Email = UserObj.Email;
          this.params.HospitalTextName = UserObj.HospitalTextName;
          this.certificateText = UserObj.CertificatePath != '' ? '有' : '';
          this.resultArea = UserObj.AreaItem;
          this.addressText = `${UserObj.AreaItem.CountryName}${UserObj.AreaItem.ProvinceName}${UserObj.AreaItem.CityName}${UserObj.AreaItem.RegionName}`;
          this.params.ZipCode = UserObj.AreaItem.ZipCode;
          this.params.TelePhone = UserObj.TelePhone;
          this.params.Introduction = UserObj.Introduction;
          this.params.UserHeadPath = UserObj.UserHeadPath;
          // guandong_20220706
          let birthDay = UserObj.Birthday || ''
          this.params.Birthday = birthDay
          if (birthDay !== '') {
            this.defaultBirthDate = new Date(birthDay)
          }
          this.getArea(1, null, false);
        }
      })
    },
    // 验证
    validateField () {
      this.$validator.extend('formatMobile', {
        getMessage: field => "请输入正确的手机号码",
        validate: (value) => {
          return /^1\d{10}$/.test(value)
        }
      });
      this.$validator.extend('formatEmail', {
        getMessage: field => "请输入正确的邮箱",
        validate: (value) => {
          return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-z0-9_-]+)+$/.test(value)
        }
      });
      this.$validator.extend('formatZipCode', {
        getMessage: field => "请输入正确的邮编",
        validate: (value) => {
          return /^[0-8][0-7]\d{4}$/.test(value)
        }
      });
    },
    //选择头像
    uploadFile ($event) {
      this.params.UserHeadPath = $event
    },
    //选择性别
    changeGenderOptData (curItem, index) {
      this.genderText = curItem.text;
      this.params.Sex = curItem.value;
      this.modalShow.gender = false;
    },
    //获取地区
    getArea (type, AreaID) {
      let subType = type;
      let areaId = AreaID;
      //   let isForeign = IsForeign;
      //   if (IsForeign && subType > 3) {
      //     this.optData.areaOpt.area = [];
      //     return;
      //   } else 
      if (subType > 4) {
        return;
      }
      let sendParams = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetAreas',
        AreaID: areaId || '',//地区编号
        Type: type,//地区分类:1:国家,2:省/州,3:市,4:县/区 
      }
      this.$Request(sendParams).then(res => {
        if (res.AreaItems && res.AreaItems.length) {
          if (this.resultArea && this.areaTemp) {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            this.optData.areaOpt[this.areaName[type]].map((item, index) => {
              if (type === 1 && (item.AreaID === this.resultArea.CountryID)) {
                this.choseAreaKey.countryIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 2 && (item.AreaID === this.resultArea.ProvinceID)) {
                this.choseAreaKey.provinceIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 3 && (item.AreaID === this.resultArea.CityID)) {
                this.choseAreaKey.cityIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
              if (type === 4 && (item.AreaID === this.resultArea.RegionID)) {
                this.choseAreaKey.areaIndex = index;
                areaId = this.optData.areaOpt[this.areaName[type]][index].AreaID;
                // isForeign = this.optData.areaOpt[this.areaName[type]][index].IsForeign;
              }
            })
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;

          } else {
            this.optData.areaOpt[this.areaName[type]] = res.AreaItems;
            areaId = this.optData.areaOpt[this.areaName[type]][0].AreaID;
            // isForeign = this.optData.areaOpt[this.areaName[type]][0].IsForeign;
            subType = type + 1;
            this.getArea(subType, areaId);
            subType++;
          }
        } else {
          this.optData.areaOpt[this.areaName[type]] = [];
        }
      })
    },
    getSubArea (picker, value, index) {
      this.areaTemp = false;
      let subLevel = parseInt(value.Type) + 1;
      let AreaID = value.AreaID;
      //   let IsForeign = value.IsForeign;
      if (value.Type == 1) {
        this.choseAreaKey.provinceIndex = 0;
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.countryIndex = index;
      } else if (value.Type == 2) {
        this.choseAreaKey.cityIndex = 0;
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.provinceIndex = index;
      } else if (value.Type == 3) {
        this.choseAreaKey.areaIndex = 0;
        this.choseAreaKey.cityIndex = index;
      } else if (value.Type == 4) {
        this.choseAreaKey.areaIndex = index;
      }
      this.getArea(subLevel, AreaID);
    },
    //跳转到证书
    handleToCertificate () {
      this.$router.push({ path: '/qualitification-certificate', replace: true })
    },
    //关闭选项弹窗
    closeModal (field) {
      this.modalShow[field] = false;
    },
    //确定选择省市区
    confirmChoseAreaData () {
      let countryText = this.optData.areaOpt.country.length && this.optData.areaOpt.country[this.choseAreaKey.countryIndex].Name;
      let provinceText = this.optData.areaOpt.province.length && this.optData.areaOpt.province[this.choseAreaKey.provinceIndex].Name;
      let cityText = this.optData.areaOpt.city.length && this.optData.areaOpt.city[this.choseAreaKey.cityIndex].Name;
      let areaText = this.optData.areaOpt.area.length && this.optData.areaOpt.area[this.choseAreaKey.areaIndex].Name;
      areaText = (areaText == 0 ? '' : areaText);
      this.addressText = countryText + '' + provinceText + '' + cityText + '' + areaText;
      //AreaID取最后一级,如果没有取上级
      if (this.optData.areaOpt.area[this.choseAreaKey.areaIndex]) {
        this.params.RegionID = this.optData.areaOpt.area[this.choseAreaKey.areaIndex].AreaID;
      } else {
        this.params.RegionID = this.optData.areaOpt.city[this.choseAreaKey.cityIndex].AreaID;
      }
      this.closeModal('area');
    },
    //保存
    handleSave () {
      this.$validator.validateAll().then(result => {
        if (result) {
          Toast.loading({
            duration: 0,
            message: '数据保存中...',
            overlay: true
          });
          this.saveDisabled = true;
          this.$Request(this.params).then(res => {
            Toast.clear();
            Toast.success({
              duration: 3000,
              message: '保存成功'
            });
            setTimeout(() => {
              this.saveDisabled = false;
              this.$router.push({ path: '/member-center' })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }
      })
    },
    // guandong_20220706
    birthConfirm (date) {
      this.params.Birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      this.showCalendar = false
    }
  },
  watch: {
    'optData.address': {
      handler (ne, ol) {
        this.optData.address = ne
      },
      deep: true
    }
  },
  mounted () {
    this.validateField();
    this.init();
  },
  components: {
    CommonUploadFile
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px;
  margin-bottom: 50px;
  overflow-y: auto;
  .header-wrap {
    width: 100%;
    margin: 20px auto;
    .head-icon-box {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      overflow: hidden;
      margin: 10px auto;
      text-align: center;
      border: 2px solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      /deep/.van-uploader__upload {
        border: 1px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
      }
      .head-name {
        color: #6c6c6c;
        font-size: 14px;
      }
    }
  }
  .content-wrap {
    padding-bottom: 100px;
  }
  .van-button--primary {
    color: #fff;
    background-color: #269cca;
    border: 0.02667rem solid #269cca;
  }
  .van-icon {
    z-index: -1 !important;
  }
}
.select-area-wrap {
  .btn {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid #eeeeee;
    a {
      color: @blue;
    }
  }
  .list-box {
    display: flex;
    justify-content: space-around;
    padding-bottom: 20px;
  }
  .area-list {
    width: 25%;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/member/personal-data.vue